module.exports = __webpack_public_path__ + "zvetseni-prsou_67_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_67_after.jpg
// module id = 1361
// module chunks = 0